<template>
    <div class="layout generalLayout">
        <AlternativeDropdown
            :backButton="backButton"
            :selectedItem="selectedWidget"
            :items="widgetList"
            type="widget"
            @select-item="selectWidget"
        />

        <AlternativeDropdown
            v-if="hasHotspots"
            :selectedItem="selectedHotspot"
            :items="hotspotList"
            type="hotspot"
            @select-item="selectHotspot"
        />
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import AlternativeDropdown from '@/components/navbarLayout/alternativeMenu/components/AlternativeDropdown';

    export default {
        name: 'GeneralLayout',
        components: {
            AlternativeDropdown
        },
        data: () => ({
            skippedHotspotType: [
                'light-variation'
            ]
        }),
        computed: {
            selectedWidget() {
                return this.widgetList.filter(el => el.active).length > 0 ? this.widgetList.filter(el => el.active)[0] : null;
            },
            widgetList() {
                return this.$props.data && this.$props.data.levels ? this.$props.data.levels : null;
            },
            selectedHotspot() {
                return this.hasHotspots ? (this.selectedWidget.hotspots.filter(el => el.active).length > 0 ? this.selectedWidget.hotspots.filter(el => el.active)[0] : null) : null;
            },
            hotspotList() {
                return this.hasHotspots ? this.selectedWidget.hotspots.filter(hotspot => !this.skippedHotspotType.includes(hotspot.type)) : null;
            },
            hasHotspots() {
                return 'hotspots' in this.selectedWidget && this.selectedWidget.hotspots.filter(hotspot => !this.skippedHotspotType.includes(hotspot.type)).length;
            }
        },
        props: {
            'data': {
                type: Object,
                required: true
            },
            'backButton': {
                type: Boolean,
                required: true
            }
        },
        methods: {
            selectWidget(item) {
                if (!item.active)
                    EventBus.$emit('generalView_SetActive', item);
            },
            selectHotspot(hotspot) {
                EventBus.$emit('hotspot_setActive', this.selectedWidget, hotspot);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/navbarLayout/alternativeMenu/GeneralLayout.vue